import DashboardView from "./DashboardView";

export const DashboardContainer = () => {
  return (
    <>
      <DashboardView></DashboardView>
    </>
  );
};
